// Raccourcis clavier de la vue Tâches : n (nouvelle tâche), / (recherche),
// 1/2/3 (changer de vue). Inactifs quand la frappe a déjà un destinataire
// (champ de saisie, contenteditable) ou qu'une modale est ouverte.
import { useEffect } from 'react';
import { useTasksStore } from '../store/tasksStore';
import { isTypingEvent } from '../lib/keyboard';

function isModalOpen(): boolean {
  return !!document.querySelector('[role="dialog"]');
}

export function useTasksShortcuts(onNewTask?: () => void) {
  const setViewMode = useTasksStore((s) => s.setViewMode);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (isTypingEvent(e) || isModalOpen()) return;

      switch (e.key) {
        case 'n': {
          const el = document.querySelector<HTMLInputElement>('[data-task-composer]');
          if (el) {
            e.preventDefault();
            el.focus();
          } else if (onNewTask) {
            e.preventDefault();
            onNewTask();
          }
          break;
        }
        case '/': {
          const el = document.querySelector<HTMLInputElement>('[data-tasks-search]');
          if (el) {
            e.preventDefault();
            el.focus();
          }
          break;
        }
        case '1':
          setViewMode('list');
          break;
        case '2':
          setViewMode('board');
          break;
        case '3':
          setViewMode('calendar');
          break;
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [setViewMode, onNewTask]);
}
